import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Upatepassword.css"
import { handleUpdatepassword, showToast } from '../Utils/utils';
import Loader from '../../Component/Loader/Loader';
import { Link } from 'react-router-dom';


const Updatepassword = () => {
  const navigate = useNavigate();
  const [currentpassword, setCurrentpassword] = useState("")
  const [newpassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const Updatepassword = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      let response = await handleUpdatepassword({
        current_password: currentpassword,
        password: newpassword,
        confirm_password: confirmPassword,
      });
      showToast(response.message, "success")
      setCurrentpassword("")
      setNewPassword("")
      setConfirmPassword("")
      setTimeout(() => {
        window.location.href = "/dashboard";
      }, [1000])

    } catch (error) {
      showToast(error.message || "Update password failed", "error", "error");
    } finally {
      setLoading(false)
    }

  }

  return (
    <>
      {loading && <Loader />}
      <div className="page-top">
        <div className="page-wrapper mx-auto px-4">
          <div className='mt-5'>
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <img class="img-fluid left-arrow-img mb-4" src="./Images/left-arrow.svg" alt="arrow"></img>
            </Link>

            <div className='d-flex justify-content-between'>
              <h3 className='provider-title'>Welcome Provider!</h3>
              <Link to="/dashboard" style={{ textDecoration: 'none' }}>
                <img className='img-fluid' src="/Images/logo.png" alt="logo image" style={{maxWidth:'100%' , height:'50px'}}/>
              </Link>

            </div>


            <h6 className='login-title mt-4'>Update password to Elderly</h6>
          </div>
          <form className='form mt-3' onSubmit={Updatepassword}>
            <div className='email d-flex flex-column gap-2 mt-3'>
              <label className='email-label'>Current Password</label>
              <input className='emailinput ' type='password' placeholder='Enter your current password' onChange={(e) => setCurrentpassword(e.target.value)} />
            </div>
            <div className='email d-flex flex-column gap-2 mt-3'>
              <label className='email-label'>New Password</label>
              <input className='emailinput ' type='password' placeholder='Enter your new password' onChange={(e) => setNewPassword(e.target.value)} />
            </div>
            <div className='email d-flex flex-column gap-2 mt-3'>
              <label className='email-label'>Confirm  Password</label>
              <input className='emailinput ' type='password' placeholder='Enter your confirm password' onChange={(e) => setConfirmPassword(e.target.value)} />
            </div>
            <div className='submitbtn-res d-sm-block d-lg-none d-md-none'>
              <button className='continue-btn-res mt-2' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
            <div className='submitbtn-wrapper d-lg-block d-md-block d-xl-block d-xxl-block d-none'>
              <button className='continue-btn mt-3' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  )
}
export default Updatepassword